export const havenOnEarth = {
  date: '7 November 2026',
  dateTime: '2026-11-07',
  location: 'MRC Auditorium, LASUTH, Ikeja, Lagos',
};
